import { Tooltip } from '@workday/canvas-kit-react/tooltip';
import { handleCsProp } from '@workday/canvas-kit-styling';
import * as React from 'react';
import { themedTooltipBodyStyles } from './tooltipSurfaceStyles';

export const ThemedTooltip = (props: React.ComponentProps<typeof Tooltip>) => (
  <Tooltip {...handleCsProp(props, [themedTooltipBodyStyles])} />
);
